import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePaginatedPrescriptionTasks = ({ page = 1, rows = 25, searchTerm = "" }) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["prescriptionTasks", tenantVal, page, rows, searchTerm],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const params = {
        page,
        rows,
      };

      if (searchTerm && searchTerm.trim()) {
        params.searchTerm = searchTerm.trim();
      }

      const response = await axiosInstance.get(`${tenantVal}/task/get/open/prescriptions`, {
        params
      });

      return response.data;
    },
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching prescription tasks" },
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: true,
  });
};
